// SEC-055: the three client-scoped param routes (/dashboard/:clientId,
// /documents/:clientId, /meetings/:clientId) are reachable by any advisor or
// admin per the route's role gate, but the backend's requireClientAccess
// still 403s an advisor with no appointment relationship to that client.
// That is a 403, not a 401 — distinct from an expired session, and must not
// be handled by the same "log the user out" path.
export const CLIENT_ACCESS_DENIED_MESSAGE = "You don't have access to this client's records.";
export const CLIENT_ACCESS_DENIED_REDIRECT = '/users';

export function isForbiddenClientAccess(data) {
  return data?.response?.status === 403;
}
